import createLucideIcon from '../createLucideIcon';

/**
 * @component @name Aperture
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgLz4KICA8bGluZSB4MT0iMTQuMzEiIHgyPSIyMC4wNSIgeTE9IjgiIHkyPSIxNy45NCIgLz4KICA8bGluZSB4MT0iOS42OSIgeDI9IjIxLjE3IiB5MT0iOCIgeTI9IjgiIC8+CiAgPGxpbmUgeDE9IjcuMzgiIHgyPSIxMy4xMiIgeTE9IjEyIiB5Mj0iMi4wNiIgLz4KICA8bGluZSB4MT0iOS42OSIgeDI9IjMuOTUiIHkxPSIxNiIgeTI9IjYuMDYiIC8+CiAgPGxpbmUgeDE9IjE0LjMxIiB4Mj0iMi44MyIgeTE9IjE2IiB5Mj0iMTYiIC8+CiAgPGxpbmUgeDE9IjE2LjYyIiB4Mj0iMTAuODgiIHkxPSIxMiIgeTI9IjIxLjk0IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/aperture
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Aperture = createLucideIcon('Aperture', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['line', { x1: '14.31', x2: '20.05', y1: '8', y2: '17.94', key: 'jdes2e' }],
  ['line', { x1: '9.69', x2: '21.17', y1: '8', y2: '8', key: '1gubuk' }],
  ['line', { x1: '7.38', x2: '13.12', y1: '12', y2: '2.06', key: '1m4d1n' }],
  ['line', { x1: '9.69', x2: '3.95', y1: '16', y2: '6.06', key: '1wye2p' }],
  ['line', { x1: '14.31', x2: '2.83', y1: '16', y2: '16', key: '1l9f4x' }],
  ['line', { x1: '16.62', x2: '10.88', y1: '12', y2: '21.94', key: '1jjvfs' }],
]);

export default Aperture;
